/**
 * Where the Lusuku customer app is downloaded from.
 * ─────────────────────────────────────────────────────────────────────────────
 * ONE place for every store link on the web client: the landing page's store
 * badges and their QR codes, the "Open in the Lusuku app" banner, the
 * restaurant deep-link fallback, and the "Get the apps" lines in WhatsApp
 * share text. Change a URL here and all of them follow.
 *
 * The URLs are kept short on purpose: the shorter the link, the fewer modules
 * in its QR code, and the easier that code is to scan off a screen.
 */

export const APP_STORE_URL =
  "https://apps.apple.com/ug/app/lusuku/id1622613658";

export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.lusuku";

/* iPhone and iPod, and iPad. iPadOS Safari reports a desktop Mac user agent,
   so an iPad is also a "Mac" with a touch screen (real Macs report 0 touch
   points). Without that second test an iPad was sent to Google Play. */
export const isIOSDevice = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/iPad|iPhone|iPod/i.test(ua)) return true;
  return /Macintosh/i.test(ua) && (navigator.maxTouchPoints || 0) > 1;
};

/* The store this device installs from: the App Store on iOS, Google Play
   everywhere else. */
export const storeUrlForDevice = () =>
  isIOSDevice() ? APP_STORE_URL : PLAY_STORE_URL;
